<template src="./index.html"></template>
<script>
import { getdata } from "./data.js";
import {
  clientApiKeyPage,
  createClientApiKey,
} from "../../../../api/superuser.js";

export default {
  name: "Superuser",
  data: function () {
    return {
      tablekey: 0,
      overlength: 0,
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      headData: getdata().headData,
      pagination: getdata().pagination,
      tableData: [],
      sort: "",
      order: "",
      createDialogVisible: false,
      createForm: {
        clientName: "",
      },
      creating: false,
    };
  },
  mounted() {},
  created() {
    this.getList();
  },
  methods: {
    geOoverLength(value) {
      this.overlength = value;
    },
    openCreateDialog() {
      this.createForm.clientName = "";
      this.createDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.clientNameInput && this.$refs.clientNameInput.focus();
      });
    },
    submitCreate() {
      const clientName = this.createForm.clientName.trim();
      if (!clientName) {
        this.$message.error("客户名称不能为空");
        return;
      }
      if (this.creating) return;
      this.creating = true;
      createClientApiKey({ clientName })
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg || "新增成功");
            this.createDialogVisible = false;
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .finally(() => {
          this.creating = false;
        });
    },
    getList() {
      const params = {
        ...this.searchdata,
        current: this.pagination.pageNum,
        size: this.pagination.pageSize,
        sort: this.sort,
        order: this.order,
      };
      clientApiKeyPage(params).then((res) => {
        if (res.data.code == 1) {
          const pageData = res.data.data || {};
          this.tableData = pageData.records || [];
          this.pagination.total = Number(pageData.total || 0);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.getList();
    },
    sizechange(value) {
      this.pagination.pageSize = value;
      this.getList();
    },
    currentChange(value) {
      this.pagination.pageNum = value;
      this.getList();
    },
    sortchange(data) {
      this.sort = data.prop;
      this.order = data.order === "ascending" ? "asc" : "desc";
      this.getList();
    },
    forback() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
